export const SKC_2026_NOVICE = [
  '烛台\nCANDLE STICK',
  '中皿-止剑\nBASE CUP, SPIKE',
  '日本一周\nAROUND JAPAN',
  '世界一周\nAROUND THE WORLD',
  '欧洲一周\nAROUND EUROPE',
  '游泳-地球\nSWING IN, EARTH TURN',
  '大鸟-止剑\nBIRD, SPIKE',
  '飞行机-跳剑\nAIRPLANE, J-STICK',
  '一回转飞行机\n1 TURN AIRPLANE',
  '灯台-持球收\nLIGHTHOUSE, IN'
];

export const SKC_2026_ADVANCED = [
  '神枪手游泳，神枪手地球\nSWING GUNSLINGER SPIKE, WHIRLSLINGER',
  '一回转飞行机，跳剑\n1 TURN AIRPLANE, J-STICK',
  '欧洲一周\nAROUND EUROPE',
  '鸟渡，NO LOOK止剑\nBIRD OVER THE VALLEY, NO-LOOK SPIKE',
  '反拉游泳，逆地球\nINWARD SWING IN, INWARD EARTH TURN',
  '飞行机，逆跳剑\nAIRPLANE, INWARD J-STICK',
  '一回灯台INSTA灯上1回，持剑收\n1 TURN LIGHTHOUSE INSTA LIGHTHOUSE FLIP, TRADESPIKE',
  '逆月，灯台，正月，入\nINWARD LUNAR, LIGHTHOUSE, LUNAR, IN',
  '天中杀，中皿，天中杀，地狱车\nDOWNSPIKE, BASE CUP, DOWNSPIKE, DOWN EARTH',
  '小丑止剑，地球\nJUGGLE SPIKE, EARTH TURN',
  '中皿极意，止剑\nHANDLESTALL, SPIKE',
  '安渡鸟，止剑\nUNDERBIRD, SPIKE',
  '竹马，天中杀\nSTILT, TRADE DOWNSPIKE',
  '2小丑止剑\nDOUBLE JUGGLE SPIKE',
  '游泳，离转地球\nSWING IN, WHIRLWIND',
  '幽灵灯台，持球收\nGHOST LIGHTHOUSE, IN',
  '月面，月上1回，1回持球收\nLUNAR, LUNAR FLIP, 1 TURN IN',
  'TAP灯台，持剑收\n1 TURN TAP LIGHTHOUSE, TRADESPIKE'
];

export const SKC_2026_PRO = [
  '逆月面，梦幻逆月面，持球收\nINWARD LUNAR, BACK FLIP INWARD LUNAR, IN',
  '飞行机，1.5端剑持剑收\nAIRPLANE, 1.5 TURN SWAP SPIKE',
  '丹麦一周\nAROUND DENMARK',
  '3神枪手止剑\nTRIPLE GUNSLINGER SPIKE',
  '竹马，竹马一回，一回入\nSTILT, STILT FLIP, 1 TURN IN',
  '逆月面，1回转CUSHION逆月面，1回转CUSHION持球收\nINWARD LUNAR, FLIP CUSHION INWARD LUNAR, FLIP CUSHION IN',
  '月面123，持球收\nLUNAR FLIP 1-2-3, IN',
  '飞行机，1.5端剑小丑大鸟止剑\nAIRPLANE, 1.5 TURN SWAP JUGGLE BIRD, SPIKE',
  '飞行机，1.5端剑抛1.5圈持球收\nAIRPLANE, 1.5 TURN SWAP 1.5 TURN IN',
  '飞行机，3跳剑\nAIRPLANE, TRIPLE J-STICK',
  '游泳，3离转小丑止剑\nSWING IN, TRIPLE-KENFLIP JUGGLE SPIKE',
  '游泳，离转LATE止剑\nSWING IN, KENFLIP LATE WHIRLWIND',
  '10小丑（以上）止剑\n10 JUGGLE SPIKE(OR MORE)',
  '天中杀快手，跳剑天中杀快手\nDOWNSPIKE FASTHAND, 1 TURN SWAP DOWNSPIKE FASTHAND',
  '一回灯台，灯上逆一回INSTA正一回，入\n1 TURN LIGHTHOUSE, INWARD LIGHTHOUSE FLIP INSTA LIGHTHOUSE FLIP, IN',
  '稻草人3秒，持球收\nBORDER BALANCE(3 SECONDS), IN',
  '2 TAP小丑2 TAP小丑止剑\n2 TAP JUGGLE 2 TAP JUGGLE SPIKE',
  '直拉2离转LATE 2离转小丑止剑\nDOUBLE KENFLIP LATE DOUBLE-KENFLIP JUGGLE SPIKE',
  '一回灯台INSTA灯上一回X3，持球收\n1 TURN LIGHTHOUSE INSTA LIGHTHOUSE FLIP X 3, IN',
  '玉中杀，一回玉中杀快手\nSTUNTPLANE, STUNT FLIP FASTHAND'
];
